import React from 'react';

import BulkClUpdateFormContainer from './FileUploadForm/BulkClUpdateForm.container';
import FileUploadHistoryContainer from './FileUploadHistory/FileUploadHistory.container';

export default function BulkContractLinsUpdateTab() {
  return (
    <>
      <BulkClUpdateFormContainer />
      <FileUploadHistoryContainer />
    </>
  );
}
